import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { useCallback } from "react";
import { z } from "zod/v4";
import { TaxAdvisoryCompanyDocumentsContent } from "../../../../../companies/documents/TaxAdvisoryCompanyDocumentsContent";

const companyRoute = getRouteApi(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId"
);

const searchSchema = z.object({
  id: z.string().optional(),
});

export const Route = createFileRoute(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/dokumente"
)({
  validateSearch: zodValidator(searchSchema),
  loader: ({
    context: { queryClient, trpc },
    params: { taxAdvisoryId, companyId },
  }) => {
    void queryClient.ensureQueryData(
      trpc.documents.listDocumentsWithSortingByCompanyId.queryOptions({
        taxAdvisoryId,
        companyId,
      })
    );
  },
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { taxAdvisoryId, companyId } = Route.useParams();
  const { id: selectedDocumentId } = Route.useSearch();
  const { jahr } = companyRoute.useSearch();
  const navigate = Route.useNavigate();

  const onSelectDocument = useCallback(
    (documentId: string) => {
      void navigate({
        search: { id: documentId },
      });
    },
    [navigate]
  );

  return (
    <TaxAdvisoryCompanyDocumentsContent
      taxAdvisoryId={taxAdvisoryId}
      companyId={companyId}
      year={jahr}
      selectedDocumentId={selectedDocumentId}
      onSelectDocument={onSelectDocument}
    />
  );
}
